module.exports = "<app-authentication></app-authentication>\n"